import axios from "../../../api/axios";
import {AxiosRequestConfig} from "axios";
import {configNew} from "../../../config";

const config = (): AxiosRequestConfig => {
  return {
    ...configNew()
  }
}

export const apiGetGameCategories = (body: any) => axios.get(`/trainers/categories`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetGamesList = (body: any) => axios.get(`/trainers/games`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetCardsList = (body: any) => axios.get(`/lists/cards`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetTalesList = (body: any) => axios.get(`/lists/cards?category_name=audio_stories`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);


export const apiGetOneGame = (body: any) => axios.get(`/trainers/game`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetOneCard = (body: any) => axios.get(`/lists/card`,
  {
    params: body,
    ...config()
  }).then(({data}) => data);

export const apiGetMaterials = (body: any) => axios.get(`/materials/filtered-tree`,
    {
      params: body,
      ...config()
    }).then(({data}) => data);

export const apiGetInfographics = (body: any) => axios.get(`/infographic/by-code`,
    {
      params: body,
      ...config()
    }).then(({data}) => data);

export const apiGetMaterialsTree = (body?: any) =>
  axios
    .get(`/materials/filtered-tree`, {
      params: body,
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetKindergartensList = (body?: any) =>
  axios
    .get(`/lists/kindergartens`, {
      params: body,
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetChildrens = (body?: any) =>
  axios
    .get(`/child`, {
      params: body,
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetMainVideoList = () =>
  axios
    .get(`/page/multimedia`, {
      params: { page: 'education cartoons' },
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetContentByLesson = (params: { categoryId: number; id?: number }) =>
  axios
    .get(`/materials/content`, { params, ...config() })
    .then(({ data }) => data);

export const apiGetExportPDF = (id: number) =>
  axios
    .get(`/materials/export-pdf`, {
      params: { id },
      responseType: "blob",
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetSensoryVideoList = (supportId: any) => {
  const page =
    supportId === 'sensory'
      ? 'parent'
      : supportId === 'neurogym'
      ? 'parent2'
      : supportId === 'speech'
      ? 'parent3'
      : supportId === 'developing'
      ? 'parent4'
      : supportId === 'fairytale'
      ? 'parent5'
      : supportId === 'familyPsychology'
      ? 'parent6'
      : 'parent';

  return axios
    .get(`/page/multimedia`, {
      params: { page },
      ...config(),
    })
    .then(({ data }) => data);
};

export const apiGetExportResultsPDF = (id: any) =>
  axios
    .get(`/test/export-pdf`, {
      params: { id },
      responseType: "blob",
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetInfographicsByCode = (codeWord: string) =>
  axios
    .get(`/infographic/by-code`, {
      params: { code: codeWord },
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetArticleById = (id: number) =>
  axios
    .get(`/article/read`, {
      params: { id },
      ...config(),
    })
    .then(({ data }) => data);

export const apiDeleteChild = (id: number) =>
  axios
    .delete(`/child/${id}`, {
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetPsychoCardsList = () =>
  axios
    .get(`/article/categories`, {
      ...config(),
    })
    .then(({ data }) => data);

export const apiUpdateProfile = (payload: any) =>
  axios
    .post(`/user/update-profile`, payload, {
      ...config(),
    })
    .then(({ data }) => data);

export const apiAddChild = (payload: any) =>
  axios.post(`/child`, payload, { ...config() }).then(({ data }) => data);

export const apiUpdateChild = ({ id, payload }: { id: any; payload: any }) =>
  axios.put(`/child/${id}`, payload, { ...config() }).then(({ data }) => data);

export const apiGetCardsThemeList = () =>
  axios
    .get(`/lists/card-categories`, { ...config() })
    .then(({ data }) => data);

export const apiEvaluate = (body: any) =>
  axios
    .post(`/test/evaluate-screening`, body, { ...config() })
    .then(({ data }) => data);

export const apiGetTestResults = (payload: { type?: any; is_no_rec?: any; user_test_id?: any }) =>
  axios
    .post(`/test/results-list`, payload, { ...config() })
    .then(({ data }) => data);

export const apiGetRegions = (parentId?: number) =>
  axios
    .get(`/lists/regions`, {
      params: { parent_id: parentId },
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetListRequest = () =>
  axios
    .get(`/test/list-request`, { ...config() })
    .then(({ data }) => data);

export const apiCreateApplication = (body: any) =>
  axios
    .post(`/test/create-request`, body, { ...config() })
    .then(({ data }) => data);

export const apiSetLike = (payload: { entity_id: any; entity_type: any }) =>
  axios
    .post(`/like/toogle`, payload, { ...config() })
    .then(({ data }) => data);

export const apiGetContentByCategory = (categoryId: number, topicId?: number) =>
  axios
    .get(`/materials/content`, {
      params: { categoryId, topic_id: topicId },
      ...config(),
    })
    .then(({ data }) => data);

export const apiGetMarathonWeeks = () =>
  axios.get(`/marathon/weeks`, {
    ...config()
  }).then(({data}) => data)

export const apiGetMarathonDays = (weekId: number | string) =>
  axios.get(`/marathon/days/${weekId}`, {
    ...config()
  }).then(({data}) => data)

export const apiGetMarathonTasks = ({ dayId, childId }: { dayId: number; childId?: number | null }) =>
  axios.get(`/marathon/tasks/${dayId}${childId ? `?child_id=${childId}` : ''}`, {
    ...config()
  }).then(({data}) => data)

export const apiGetMarathonTask = (id: number | string) =>
  axios.get(`/marathon/task/${id}`, {
    ...config()
  }).then(({data}) => data)

export const apiSaveDiary = (body: any) =>
  axios
    .post(`/marathon/diary`, body, { ...config() })
    .then(({ data }) => data);

export const apiGetDiary = ({ dayId, childId }: { dayId: number; childId: number }) =>
  axios
    .get(`/marathon/diary/${dayId}?child_id=${childId}`, { ...config() })
    .then(({ data }) => data);

export const apiGetDiaryTable = ({ weekId, childId }: { weekId: number; childId: number }) =>
  axios
    .get(`/marathon/diary-table/${weekId}?child_id=${childId}`, { ...config() })
    .then(({ data }) => data);

export const apiTaskComplete = (body: { child_id: number; task_id: number; completed: boolean }) =>
  axios
    .post(`/marathon/task-complete`, body, { ...config() })
    .then(({ data }) => data);